/**
 * The named three.js layer bits of the perf pass (plan `docs/plans/2026-10-11-perf-pass.md` §0.3, PF-0). three draws
 * an object when *any* of its bits matches the camera's (`Layers.test` is an OR), so keeping an object out of a pass
 * means moving it off bit 0 onto a bit that pass's camera lacks:
 * - `SHADOW_CASTER`: objects only the shadow levels draw (PF-2's coarse rock casters);
 * - `SCENE_ONLY`: objects the scene pass draws but the AO prepass skips (PF-7);
 * - `DYNAMIC_CASTER`: casters a cached outer shadow level leaves to the live levels (PF-6);
 * - `SHADOW_NEAR`: casters only the two finest shadow levels draw (PF-2b's near rocks at their visible LOD).
 * Bit 0 is three's default; every bit here is distinct and not 0.
 */
import type { Camera } from 'three'

export const SHADOW_CASTER = 4
export const SCENE_ONLY = 5
export const DYNAMIC_CASTER = 6
export const SHADOW_NEAR = 7

/** Every named bit, for the distinctness test. */
export const NAMED_LAYERS: readonly number[] = [SHADOW_CASTER, SCENE_ONLY, DYNAMIC_CASTER, SHADOW_NEAR]

/**
 * Enables the bits the main camera draws: 0, `SCENE_ONLY` and `DYNAMIC_CASTER` (not `SHADOW_CASTER` or `SHADOW_NEAR`). Called once on
 * the main camera at creation; harmless until a card puts objects on those bits.
 */
export function enableSceneLayers(camera: Camera): void {
  camera.layers.enable(0)
  camera.layers.enable(SCENE_ONLY)
  camera.layers.enable(DYNAMIC_CASTER)
}
